import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-32" data-mp="196yg4h8yy68k">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-33" data-mp="197zuaula78ui">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-gold-400 px-5 py-4 font-display text-base font-black uppercase text-navy-950 shadow-[0_6px_0_0_#c98f00,0_14px_30px_-6px_rgba(5,15,36,0.45)] ring-2 ring-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/60" data-id="element-34" data-mp="2f5vaswzpj9gj">
            <span className="whitespace-nowrap" data-id="element-35" data-mp="1idrqjyff27n4">Get instant access — $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1ifuqpbaa9h5k" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}